import { Component, OnInit, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { PathLocationStrategy } from '@angular/common';
import {Router} from '@angular/router';
import {MenuItem} from 'primeng/api';
import { constants } from '../app-constants';
import { OrdemServicoIn } from '../model';
import { CriarOSConfirmacaoComponent } from '../criar-osconfirmacao/criar-osconfirmacao.component';
import {AdvGrowlService} from 'primeng-advanced-growl';
import { PropertiesLocales } from '../util/properties-locale';

@Component({
  selector: 'app-criar-os',
  templateUrl: './criar-os.component.html',
  styleUrls: ['./criar-os.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class CriarOSComponent implements OnInit {
  public items: MenuItem[];
  public osin: OrdemServicoIn;
  public isVisible: Boolean;
  public activeIndex: number;
  public isDisabled: boolean;
  public enderecoSelecionado: any;
  public tipoOsSelecionado: any;
  public properties: PropertiesLocales = new PropertiesLocales();
  public msg: any;
  public basePath: string;

  @Output() responseOS = new EventEmitter();

  constructor(private advGrowlService: AdvGrowlService,
              private criarOSConfirmacaoComponent: CriarOSConfirmacaoComponent,
              private router: Router,
              private pathLocationStrategy: PathLocationStrategy) {
      this.activeIndex = 0;
  }

  ngOnInit() {
    this.basePath = this.pathLocationStrategy.getBaseHref();
    let local = localStorage.getItem(constants.locale);
    const uri = this.basePath.substring(7).replace('/', '').toString();

    if (!local.match(uri)) { // prevalece o locale definido na URL
      local = uri.replace('/', '');
    }

    switch (local) {
      case 'en':
       this.carregarMenu(this.properties.items_steps_en);
       this.msg = this.properties.items_steps_en;
      break;

      case 'es':
      this.carregarMenu(this.properties.items_steps_es);
      this.msg = this.properties.items_steps_es;
      break;

      default:
      this.carregarMenu(this.properties.items_steps_pt);
      this.msg = this.properties.items_steps_pt;
      break;
    }

    this.isDisabled = false;
  }

  confirmar() {
    this.isDisabled = true;
    this.criarOSConfirmacaoComponent.criarOs(this.advGrowlService, this.msg);
    this.clearComponentsOS();
    this.selecionarCliente();
  }

  clearComponentsOS() {
    localStorage.setItem(constants.tipoosSelecionadoKey, JSON.stringify(null));
    localStorage.setItem(constants.enderecoSelecionadoKey, JSON.stringify(null));
    localStorage.setItem(constants.ativoKey, JSON.stringify(null));
    localStorage.setItem(constants.ambientes, JSON.stringify(null));
    localStorage.setItem(constants.anexosKey, JSON.stringify(null));
  }

  public selecionarCliente(): void {
    this.activeIndex = 0;
    this.isVisible = !this.isVisible;
     this.isDisabled = false;
  }

  public selecionarAtivo() {
    this.activeIndex = 1;
  }

  public selecionarEndereco() {
    this.activeIndex = 2;
  }

  public selecionarAmbiente() {
    this.activeIndex = 3;
  }

  public selecionarAnexos() {
    this.activeIndex = 5;
  }

  public selecionarTipoOS(): boolean {
    this.enderecoSelecionado = JSON.parse(localStorage.getItem(constants.enderecoSelecionadoKey));
    if (this.enderecoSelecionado == null) {
      this.advGrowlService.createTimedErrorMessage(this.msg[10].msg_service_select_address, this.msg[9].msg_service_required, 3000);
      return false;
    } else {
      return true;
    }
  }

  public carregarMenu(local: any) {
    this.items = [{
      label: local[0].name,
      command: (event: any) => {
        this.activeIndex = 0;
        this.selecionarCliente();
      }
    },
    {
      label: local[1].name,
      command: (event: any) => {
        this.activeIndex = 1;
      }
    },
      {
        label: local[2].name,
        command: (event: any) => {
          this.activeIndex = 2;
        }
      },
      {
        label: local[3].name,
        command: (event: any) => {
          this.activeIndex = 3;
        }
      },
      {
        label: local[4].name,
        command: (event: any) => {
          this.activeIndex = 4;
        }
      },
      {
        label: local[21].name,
        command: (event: any) => {
          this.activeIndex = 5;
        }
      },
      {
        label: local[5].name,
        command: (event: any) => {
          this.activeIndex = 6;
        }
      }
    ];
  }

  public next() {
    if (this.activeIndex === 0) {
      this.activeIndex++;
      this.isVisible = true;
      return;
    }

    if (this.activeIndex === 1) {
      this.activeIndex++;
      this.isVisible = true;
      return;
    }

    if (this.activeIndex === 2) {
      if (this.selecionarTipoOS()) {
        this.activeIndex++;
      }
      this.isVisible = true;
      return;
    }

    if (this.activeIndex === 3) {
      this.activeIndex++;
      this.isVisible = true;
      return;
    }

    if (this.activeIndex === 4) {
      this.activeIndex++;
      this.isVisible = true;
      return;
    }

    if (this.activeIndex === 5) {
      this.activeIndex++;
      this.isVisible = true;
      return;
    }

    if (this.activeIndex === 6) {
        this.tipoOsSelecionado = JSON.parse(localStorage.getItem(constants.tipoosSelecionadoKey));
        if (this.tipoOsSelecionado == null) {
          const message = this.msg[11].msg_service_select_servicetype;
              this.advGrowlService.createTimedErrorMessage(message, this.msg[9].msg_service_required, 3000);
              return;
        } else {
          this.activeIndex++;
        }
    }
  }

  public previous() {
    this.isDisabled = false;
    this.activeIndex--;
    if (this.activeIndex === 0 && this.isVisible) {
       this.isVisible = !this.isVisible;
    }
  }
}
